import { IconProps } from 'src/utils/icon';

const CalendarPastIcon: React.FC<IconProps> = ({ size = 1, fill = '#000' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 54 44"
  >
    <path
      fill={fill}
      stroke="#2c2a29"
      d="M52.045 17.227c-.572 0-.954.382-.954.955v10.5c0 1.05-.86 1.91-1.91 1.91h-1.908c-1.623 0-2.864 1.24-2.864 2.863v1.909c0 1.05-.859 1.909-1.909 1.909H13.864c-.573 0-.955-.382-.955-.955V18.182c0-.573-.382-.954-.954-.954-.573 0-.955.381-.955.954v18.136c0 1.623 1.24 2.864 2.864 2.864H43.74c1.242 0 2.483-.477 3.342-1.432l4.486-4.486c.86-.86 1.432-2.1 1.432-3.341V18.182c0-.573-.382-.954-.955-.954zm-5.822 18.805c0-.19.095-.382.095-.668v-1.91c0-.572.382-.954.955-.954h1.909c.19 0 .382 0 .668-.095l-3.627 3.627zM50.136 3.864h-6.681v-1.91c0-.572-.382-.954-.955-.954s-.955.382-.955.955v1.909h-19.09v-1.91c0-.572-.382-.954-.955-.954s-.954.382-.954.955v1.909h-6.682C12.24 3.864 11 5.104 11 6.727v7.637c0 .572.382.954.954.954h40.091c.573 0 .955-.382.955-.954V6.727c0-1.622-1.24-2.863-2.864-2.863zm.955 9.545H12.909V6.727c0-.572.382-.954.955-.954h6.681v2.195c-.572.287-.954.955-.954 1.623 0 1.05.86 1.91 1.91 1.91 1.05 0 1.908-.86 1.908-1.91 0-.668-.382-1.336-.954-1.623V5.773h19.09v2.195c-.572.287-.954.955-.954 1.623 0 1.05.86 1.91 1.91 1.91 1.05 0 1.908-.86 1.908-1.91 0-.668-.382-1.336-.954-1.623V5.773h6.681c.573 0 .955.382.955.954v6.682h0z"
    />
    <path
      fill="#2c2a29"
      d="M28.182 22.954a1.91 1.91 0 100-3.818 1.91 1.91 0 000 3.818zM35.818 22.954a1.91 1.91 0 100-3.818 1.91 1.91 0 000 3.818zM43.455 22.954a1.91 1.91 0 100-3.818 1.91 1.91 0 000 3.818zM20.545 31.546a1.91 1.91 0 100-3.819 1.91 1.91 0 000 3.819zM28.182 31.546a1.91 1.91 0 100-3.818 1.91 1.91 0 000 3.818zM35.818 31.546a1.91 1.91 0 100-3.818 1.91 1.91 0 000 3.818z"
    />
    <circle
      cx="12"
      cy="32"
      r="11"
      fill="#fff"
      stroke="#2c2a29"
      strokeWidth="2"
    />
    <path
      fill="#2c2a29"
      stroke="#2c2a29"
      d="M7.258 27h1.018a.259.259 0 01.258.27l-.086 1.778a5.315 5.315 0 014.06-1.876 5.339 5.339 0 015.327 5.332 5.328 5.328 0 01-8.898 3.951.258.258 0 01-.01-.374l.73-.73a.258.258 0 01.352-.013 3.781 3.781 0 10-.64-4.948l2.18-.104a.257.257 0 01.27.257v1.019a.258.258 0 01-.257.258H7.258A.258.258 0 017 31.562v-4.304A.258.258 0 017.258 27z"
    />
  </svg>
);

export default CalendarPastIcon;
